import { TransitionMap } from '../types';
import { collapsedStyles } from '../consts';

export const createTransitionMap = ({
  desktopDefaultStyles,
  mobileDefaultStyles,
  desktopSupportWindowStyles,
  mobileSupportWindowStyles,
}: {
  desktopDefaultStyles: Record<string, unknown>;
  mobileDefaultStyles: Record<string, unknown>;
  desktopSupportWindowStyles: Record<string, unknown>;
  mobileSupportWindowStyles: Record<string, unknown>;
}): TransitionMap => {
  return {
    FAB: {
      hide: {
        startTransitionMessageType: { type: 'hide-fab' },
        completeTransitionMessageType: { type: 'hide-fab-transition-complete' },
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    WINDOW: {
      hide: {
        startTransitionMessageType: { type: 'hide-support-window' },
        completeTransitionMessageType: { type: 'hide-support-window-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
          ...collapsedStyles,
        }),
      },
      HIDDEN: {
        show: {
          startTransitionMessageType: { type: 'show-hidden' },
          completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
        },
        styles: () => ({ display: 'none' }),
      },
    },
    HIDDEN: {
      hide: {
        startTransitionMessageType: { type: 'show-hidden' },
        completeTransitionMessageType: { type: 'show-hidden-transition-complete' },
      },
      FAB: {
        show: {
          startTransitionMessageType: { type: 'show-fab' },
          completeTransitionMessageType: { type: 'show-fab-transition-complete' },
        },
        styles: (isDesktop) => ({
          ...(isDesktop ? desktopDefaultStyles : mobileDefaultStyles),
          ...collapsedStyles,
        }),
      },
      WINDOW: {
        show: {
          startTransitionMessageType: { type: 'show-support-window' },
          completeTransitionMessageType: { type: 'show-support-window-transition-complete' },
        },
        styles: (isDesktop) => (isDesktop ? desktopSupportWindowStyles : mobileSupportWindowStyles),
      },
    },
  };
};
